export const PHARMACY_LPU_TYPE_ID = 51 as const
export const WELLNESS_LPUTYPE = 'wellness' as const
export const SHOW_ALL_THRESHOLD = 5 as const

export const EXPERIENCE_OPTIONS = [
  { name: 'от 5 лет', value: '5' },
  { name: 'от 15 лет', value: '15' },
] as const

export const APPOINTMENT_REDIRECT_TYPE = {
  DEFAULT: 'default',
  CLUB: 'club',
  HOME: 'na_dom',
  TELEMED: 'telemed',
  TELEMED_MT: 'telemed_mt',
} as const

export const PLACE_TYPE_LABEL = {
  clinic: 'В клинику',
  home: 'На дом',
  telemed: 'На онлайн-консультацию',
} as const
